import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { FormsModule } from '@angular/forms';
import { CompanyPageComponent } from './company-page.component';
import { VoiceInputModule } from 'src/app/shared/ai-assistant/voice-input/voice-input.module';
import { FormalizeCommentModule } from 'src/app/shared/ai-assistant/formalize-comment/formalize-comment.module';
import { CompanyPageStepDetailsModule } from './company-page-step-details/company-page-step-details.module';
import { CompanyPageStepContactModule } from './company-page-step-contact/company-page-step-contact.module';
import { CompanyPageStepUsersModule } from './company-page-step-users/company-page-step-users.module';
import { CompanyPageStepPlanModule } from './company-page-step-plan/company-page-step-plan.module';
import { CompanyPageModifyPlanModalModule } from './company-page-modify-plan-modal/company-page-modify-plan-modal.module';
import { CompanyPageStepLicenseScoringModule } from './company-page-step-license-scoring/company-page-step-license-scoring.module';
import { CompanyPageStepLicenseAssessmentsModule } from './company-page-step-license-assessments/company-page-step-license-assessments.module';
import { CompanyPageStepLicenseJobboardsModule } from './company-page-step-license-jobboards/company-page-step-license-jobboards.module';
import { CompanyPageStepLicenseModule } from './company-page-step-license/company-page-step-license.module';
import { CompanyPageChooseJobBoardCredentialTypeModalModule } from './company-page-choose-job-board-credential-type-modal/company-page-choose-job-board-credential-type-modal.module';
import { CompanyPageDeleteAssessmentCredentialModalModule } from './company-page-delete-assessment-credential-modal/company-page-delete-assessment-credential-modal.module';
import { CompanyPageStepVendorsModule } from './company-page-step-vendors/company-page-step-vendors.module';
import { CompanyPageDisassociateVendorsModalModule } from './company-page-disassociate-vendors-modal/company-page-disassociate-vendors-modal.module';
import { CompanyPageStepClientBusModule } from './company-page-step-client-bus/company-page-step-client-bus.module';
import { CompanyPageDeleteCompanyContactModalModule } from './company-page-delete-company-contact-modal/company-page-delete-company-contact-modal.module';
import { CompanyPageChangeCompanyStateModalModule } from './company-page-change-company-state-modal/company-page-change-company-state-modal.module';
import { CompanyPageWorkflowStepWarningModalModule } from './company-page-workflow-step-warning-modal/company-page-workflow-step-warning-modal.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.companymanagement',
    url: '/companymanagement',
    component: CompanyPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      companyObject: null,
      userId: null,
      accessMode: null,
      addClient: null,
      updateClient: null,
      bu: null,
      clientOrBuObject: null,
      selectedCompanyId: null,
      isAssociatedClient: null,
      vendorId: null
    }
  }
];

@NgModule({
  declarations: [CompanyPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    VoiceInputModule,
    FormalizeCommentModule,
    CompanyPageStepDetailsModule,
    CompanyPageStepContactModule,
    CompanyPageStepUsersModule,
    CompanyPageStepPlanModule,
    CompanyPageModifyPlanModalModule,
    CompanyPageStepLicenseScoringModule,
    CompanyPageStepLicenseAssessmentsModule,
    CompanyPageStepLicenseJobboardsModule,
    CompanyPageStepLicenseModule,
    CompanyPageChooseJobBoardCredentialTypeModalModule,
    CompanyPageDeleteAssessmentCredentialModalModule,
    CompanyPageStepVendorsModule,
    CompanyPageDisassociateVendorsModalModule,
    CompanyPageStepClientBusModule,
    CompanyPageDeleteCompanyContactModalModule,
    CompanyPageChangeCompanyStateModalModule,
    CompanyPageWorkflowStepWarningModalModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [CompanyPageComponent],
  entryComponents: [CompanyPageComponent]
})
export class CompanyPageModule { }
